import modalAdd from './view/modalAdd.html'
import modalOrg from './view/modalOrg.html'
import modalSynchro from './view/modalSynchro.html'
import utils from 'utils'
export default class taxControlCtrl {
    constructor($scope, httpRequest, $state, sweetalert, logger, $uibModal, initSortService, globalFn) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                serverAddress: '',
                serverCode: '',
                serverType: '',
            },
        }
        const typecodeArrStr = '["server_type"]'
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.reset = function () {
            $scope.queryParam.param = {
                serverAddress: '',
                serverCode: '',
                serverType: '',
            }
        }
        // $scope.reset()
        $scope.queryList = function queryList() {
            httpRequest.post_getPageServerList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
            })
        }
        $scope.queryList()
        $scope.editHandle = function editHandle(itemData) {
            itemData = itemData && JSON.parse(JSON.stringify(itemData))
            $uibModal
                .open({
                    template: modalAdd,
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'formvalidateApi',
                        'logger',
                        'globalFn',
                        '_props',
                        function ($scope, $uibModalInstance, formvalidateApi, logger, globalFn, _props) {
                            $scope.title = _props.itemData ? '编辑' : '新增'
                            $scope.loading = false
                            $scope.serverType = _props.serverType
                            if (!_props.itemData) {
                                let defaultServerType = $scope.serverType.filter((item) => item.enumCode == '1')[0]
                                $scope.params = {
                                    serverAddress: '',
                                    serverPort: '',
                                    serverCode: '',
                                    serverType: defaultServerType ? defaultServerType.enumCode : '',
                                    capacity: 54,
                                }
                            } else {
                                $scope.params = _props.itemData
                                $scope.params.serverType = String($scope.params.serverType)
                            }
                            // 电话校验规则
                            $scope.validateRules = {
                                serverAddress: [
                                    {
                                        erromsg: '服务器IP填写不正确',
                                        condition(value) {
                                            const result = globalFn.isIp(value)
                                            return !result
                                        },
                                    },
                                ],
                                serverPort: [
                                    {
                                        erromsg: '服务器端口填写不正确',
                                        condition(value) {
                                            let result = globalFn.isPort(value)
                                            // true 标示显示 errmsg  false 标示验证通过
                                            return !result
                                        },
                                    },
                                ],
                                serverCode: [
                                    {
                                        erromsg: '服务器编号填写不正确',
                                        condition(value) {
                                            let result = value && String(value).length < 4
                                            return !result
                                        },
                                    },
                                ],
                                capacity: [
                                    {
                                        erromsg: '容量填写不正确',
                                        condition(value) {
                                            let caReg = /(^[1-9]\d*$)/
                                            let result = 0 < value && value < 1000000 && caReg.test(value)
                                            return !result
                                        },
                                    },
                                ],
                            }

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss()
                            }
                            $scope.ok = function () {
                                const mark = formvalidateApi.run()
                                if (!mark) {
                                    return false
                                }
                                $scope.loading = true
                                if (_props.itemData) {
                                    httpRequest
                                        .put_uptSysInvoiceServer($scope.params)
                                        .then((res) => {
                                            logger.logSuccess(res.data.value)
                                            $uibModalInstance.close()
                                        })
                                        .finally(() => {
                                            $scope.loading = false
                                        })
                                } else {
                                    httpRequest
                                        .post_saveSysInvoiceServer($scope.params)
                                        .then((res) => {
                                            logger.logSuccess(res.data.value)
                                            $uibModalInstance.close()
                                        })
                                        .finally(() => {
                                            $scope.loading = false
                                        })
                                }
                            }
                        },
                    ],
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        _props() {
                            return {
                                itemData,
                                serverType: $scope.dictData.server_type,
                            }
                        },
                    },
                })
                .result.then(() => {
                    $scope.queryList()
                })
        }
        // 表格下拉框
        $scope.tableDropdownConfig = [
            {
                label: '编辑',
                handler(item) {
                    $scope.editHandle(item)
                },
                showWhile(item) {
                    return true
                },
            },
            {
                label: '同步',
                handler(item) {
                    $uibModal
                        .open({
                            template: modalOrg,
                            controller: [
                                '$scope',
                                '$uibModalInstance',
                                'logger',
                                'httpRequest',
                                '_props',
                                function ($scope, $uibModalInstance, logger, httpRequest, _props) {
                                    let { serverId } = _props
                                    $scope.orgList = []
                                    $scope.queryParam = {
                                        pageNum: 1,
                                        pageSize: 99999,
                                        param: {
                                            saleCreditCode: '',
                                            saleName: '',
                                        },
                                    }
                                    $scope.getOrgList = function getOrgList() {
                                        httpRequest.post_getPageSaleInfoList($scope.queryParam).then((res) => {
                                            let result = res.data.value
                                            $scope.orgList = result.list
                                        })
                                    }
                                    $scope.getOrgList()
                                    $scope.selectedUploadRows = []
                                    $scope.cancel = function () {
                                        $uibModalInstance.dismiss()
                                    }
                                    $scope.synchro = function (type) {
                                        let result = []
                                        if ($scope.selectedUploadRows.length == 0) {
                                            logger.logError('请选择同步数据')
                                            return
                                        }
                                        $scope.selectedUploadRows.forEach((item) => {
                                            let obj = {
                                                serverId: serverId,
                                                creditCode: item.saleCreditCode,
                                                saleId: item.saleId,
                                                tenantId: item.tenantId,
                                            }
                                            result.push(obj)
                                        })
                                        $scope.loading = true
                                        httpRequest
                                            .post_sysTaxDiskSyncDisk(result)
                                            .then((res) => {
                                                if (res.data.success) {
                                                    $uibModalInstance.close(res.data.value)
                                                } else {
                                                    $scope.loading = false
                                                    logger.logError(res.data.message)
                                                }
                                            })
                                            .catch((err) => {
                                                $scope.loading = false
                                            })
                                    }
                                    $scope.asynSynchro = function (type) {
                                        let result = []
                                        if ($scope.selectedUploadRows.length == 0) {
                                            logger.logError('请选择同步异步数据')
                                            return
                                        }
                                        $scope.selectedUploadRows.forEach((item) => {
                                            let obj = {
                                                serverId: serverId,
                                                creditCode: item.saleCreditCode,
                                                saleId: item.saleId,
                                                tenantId: item.tenantId,
                                            }
                                            result.push(obj)
                                        })
                                        httpRequest
                                            .post_sysTaxDiskAsyncDisk(result)
                                            .then((res) => {
                                                if (res.data.success) {
                                                    logger.logSuccess('异步同步中，请稍后在金税盘管理查看同步结果')
                                                    $uibModalInstance.dismiss()
                                                }
                                            })
                                            .catch((err) => {})
                                    }
                                },
                            ],
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-lg',
                            resolve: {
                                _props() {
                                    return {
                                        serverId: item.serverId,
                                    }
                                },
                            },
                        })
                        .result.then((data) => {
                            if (data) {
                                utils.loading('正在同步')
                                let count = 1
                                let timer = setInterval(() => {
                                    count++
                                    if (count > 80) {
                                        utils.loaded()
                                        clearInterval(timer)
                                        timer = null
                                        logger.logError('同步失败！')
                                        return
                                    }
                                    httpRequest.get_sysServerSyncBatch(data).then((res) => {
                                        let result = res.data.value
                                        if (result.syncState == 2) {
                                            utils.loaded()
                                            clearInterval(timer)
                                            timer = null
                                            if (!result.remark) {
                                                logger.logSuccess('同步成功，您可以通过税控设备管理列表中查看同步的分机盘信息！')
                                            } else {
                                                $uibModal.open({
                                                    template: modalSynchro,
                                                    controller: [
                                                        '$scope',
                                                        '$uibModalInstance',
                                                        '_props',
                                                        function ($scope, $uibModalInstance, _props) {
                                                            let { remark, requestNum } = _props.result
                                                            $scope.requestNum = requestNum
                                                            let markArr = remark.split('||')
                                                            $scope.listData = []
                                                            let listData = []
                                                            markArr.forEach((item) => {
                                                                if (item) {
                                                                    let itemArr = item.split('&&')
                                                                    let obj = {
                                                                        creditCode: itemArr[0],
                                                                        reason: itemArr[1],
                                                                    }
                                                                    listData.push(obj)
                                                                }
                                                            })
                                                            $scope.listData = listData
                                                            $scope.requestSuccess = $scope.requestNum - listData.length
                                                            $scope.cancel = function () {
                                                                $uibModalInstance.dismiss()
                                                            }
                                                            $scope.ok = function () {
                                                                $uibModalInstance.close()
                                                            }
                                                        },
                                                    ],
                                                    backdrop: 'static',
                                                    openedClass: 'mod-modal mod-modal-lg',
                                                    resolve: {
                                                        _props() {
                                                            return {
                                                                result,
                                                            }
                                                        },
                                                    },
                                                })
                                            }
                                        }
                                    })
                                }, 1500)
                            }
                        })
                },
                showWhile(item) {
                    return true
                },
            },
        ]
        // 表头排序
        $scope.orderMap = initSortService('taxControlParam')
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('taxControlParam', JSON.stringify($scope.queryParam))
            $scope.queryList()
        }
    }
}
taxControlCtrl.$inject = ['$scope', 'httpRequest', '$state', 'sweetalert', 'logger', '$uibModal', 'initSortService', 'globalFn']



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxControl/list.js